import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

/**
 * 🔹 Payload para crear/actualizar
 */
export interface PesvViasHallazgosPayload {
  via_id: number;
  zona_id?: number | null;
  riesgo_id?: number | null;
  inspeccion_id: number;
  codigo: string;
  tipo_hallazgo: number;
  descripcion: string;
  condicion_encontrada?: string | null;
  causa?: string | null;
  consecuencia?: string | null;
  nivel_riesgo?: number | null;
  probabilidad?: number | null;
  consecuencia_nivel?: number | null;
  prioridad?: number | null;
  requiere_accion?: boolean;
  fecha_deteccion: string;
  fecha_compromiso?: string | null;
  estado?: number;
  observaciones?: string | null;
  created_by?: number | null;
  updated_by?: number | null;
}

/**
 * 🔹 Entidad
 */
export interface PesvViasHallazgos {
  id?: number;
  via_id: number;
  zona_id?: number | null;
  riesgo_id?: number | null;
  inspeccion_id: number;
  codigo: string;
  tipo_hallazgo: number;
  descripcion: string;
  condicion_encontrada?: string | null;
  causa?: string | null;
  consecuencia?: string | null;
  nivel_riesgo?: number | null;
  probabilidad?: number | null;
  consecuencia_nivel?: number | null;
  prioridad?: number | null;
  requiere_accion: boolean;
  fecha_deteccion: string;
  fecha_compromiso?: string | null;
  estado: number;
  observaciones?: string | null;
  created_by?: number | null;
  updated_by?: number | null;
  fechaCreacion?: string;
  fechaModificacion?: string;
}

/**
 * 🔹 Respuesta genérica
 */
export interface PesvViasHallazgosResponse {
  id?: number;
  message?: string;
  error?: string;
  data?: any;
  [key: string]: any;
}

@Injectable({
  providedIn: "root",
})
export class PesvViasHallazgosService {
  private readonly apiUrl = `${environment.apiUrl}/api/pesv_vias_hallazgos`;

  constructor(private http: HttpClient) {}

  /**
   * Obtener todos los hallazgos
   */
  getAll(): Observable<PesvViasHallazgos[]> {
    return this.http.get<PesvViasHallazgos[]>(this.apiUrl, {
      withCredentials: true,
    });
  }

  /**
   * Obtener hallazgo por ID
   */
  getById(id: number): Observable<PesvViasHallazgos> {
    return this.http.get<PesvViasHallazgos>(
      `${this.apiUrl}/${id}`,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Crear hallazgo
   */
  create(
    payload: PesvViasHallazgosPayload
  ): Observable<PesvViasHallazgosResponse> {
    return this.http.post<PesvViasHallazgosResponse>(
      this.apiUrl,
      payload,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Actualizar hallazgo
   */
  update(
    id: number,
    payload: Partial<PesvViasHallazgosPayload>
  ): Observable<PesvViasHallazgosResponse> {
    return this.http.put<PesvViasHallazgosResponse>(
      `${this.apiUrl}/${id}`,
      payload,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Eliminar hallazgo
   */
  remove(id: number): Observable<any> {
    return this.http.delete<any>(
      `${this.apiUrl}/${id}`,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Inactivar hallazgo
   */
  inactivar(id: number): Observable<PesvViasHallazgosResponse> {
    return this.http.put<PesvViasHallazgosResponse>(
      `${this.apiUrl}/${id}/inactivar`,
      {},
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Activar hallazgo
   */
  activar(id: number): Observable<PesvViasHallazgosResponse> {
    return this.http.put<PesvViasHallazgosResponse>(
      `${this.apiUrl}/${id}/activar`,
      {},
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Obtener hallazgos por zona
   */
  getHallazgosZona(
    zonaId: number
  ): Observable<PesvViasHallazgos[]> {
    return this.http.get<PesvViasHallazgos[]>(
      `${this.apiUrl}/zona/${zonaId}`,
      {
        withCredentials: true,
      }
    );
  }
}